module.exports = __webpack_public_path__ + "assets/img/img328.56283457.png";